import { api } from './api';

export interface StaffQueryParams {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    status?: string;
}

// GET all staff members (paginated, filtered)
export const getStaffList = (params?: StaffQueryParams) =>
    api.get('/admin/staff', { params });

// GET full staff details
export const getStaffDetails = (id: number) =>
    api.get(`/admin/staff/${id}`);

// GET one level of a staff member's tree with per-person own + branch numbers
export const getStaffStats = (id: number) =>
    api.get(`/admin/staff/${id}/stats`);

// POST onboard new staff
export const createStaff = (data: any) =>
    api.post('/admin/staff', data);

// PATCH update existing staff (also used for activating/suspending)
export const updateStaff = (id: number, data: any) =>
    api.patch(`/admin/staff/${id}`, data);